export const COMMISSION_PROMOTIONS_ROUTE_PREFIX = "/commissions/promotions";

export const COMMISSION_PROMOTIONS_ROUTE_PATHS = {
  list: { path: "*", to: COMMISSION_PROMOTIONS_ROUTE_PREFIX },
};
